import React from 'react';
import { X, Loader2 } from 'lucide-react';

export function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmText, loading, variant = 'primary', children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="p-4 border-b"><h3 className="font-semibold">{title}</h3></div>
        <div className="p-6">
          <p className="text-slate-600 mb-2 text-center">{message}</p>
          {children}
          {!children && <p className="text-sm text-slate-500 text-center">Click confirm to continue</p>}
        </div>
        <div className="p-4 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm border border-slate-300 rounded">Cancel</button>
          <button onClick={onConfirm} disabled={loading} className={`px-4 py-2 text-sm text-white rounded flex items-center gap-2 ${variant === 'danger' ? 'bg-red-500' : 'bg-primary'}`}>
            {loading && <Loader2 size={16} className="animate-spin" />}
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

// Create Job Modal


